import { useNavigate } from 'react-router-dom';

function BackButtonRenderer({ comp }) {
    const navigate = useNavigate();

    if (!comp?.parentPath) return null;

    return (
        <button className="btn-back" onClick={() => navigate(`/${comp.parentPath}`)}>
            {comp.title || 'Back'}
        </button>
    );
}

export default BackButtonRenderer;
